module.exports = __webpack_public_path__ + "media/images/e-bilet/Hero_Tickets-5384bbf0044de0929cc4d1350cf8a481.webp";